<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Qhome",
  data(){
    return{
      user:localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{},
    }
  }
}
</script>
<template>
  <div>

    <el-menu
        style="position: fixed; top: 0; left: 0; z-index: 60;right: 0"
        :default-active="$route.path"
        class="el-menu-demo"
        mode="horizontal"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        router
    >
      <el-menu-item index="/info">个人资料</el-menu-item>
      <el-menu-item index="/novels">阅读</el-menu-item>
      <el-menu-item index="/reads">写小说</el-menu-item>
      <el-menu-item index="/message">聊天</el-menu-item>
      <el-menu-item index="/img" >图片查询</el-menu-item>
      <el-menu-item index="/read">后台管理</el-menu-item>
    </el-menu>

    <el-main style="padding-top: 52px;">
      <el-scrollbar >
      <router-view></router-view>
      </el-scrollbar>
    </el-main>

  </div>

</template>

<style scoped>
.el-main {
  padding: 0;
  margin-top: 0;
}
</style>